import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Typography, useMediaQuery } from '@mui/material';
import MLIcon from '../../../MLIcon';
import { CLOSE_SIDE_PANEL } from '../../../SidePanel/store/actions';
import useSidePanel from '../../../SidePanel/hooks/useSidePanel';

import s from './FilterButton.module.css';
import MLButton from '../../../MLButton';
import { toggleShowFilterOptionsGradebook } from '../../../../actions/filter';

const FilterButton = forwardRef(function FilterButton(
  { dispatch, showFilterOptions },
  ref,
) {
  const { state: sidePanelState, dispatch: sidePanelDispatch } = useSidePanel();
  const {
    mediaQueries: { medium },
  } = sidePanelState;

  const isMedium = useMediaQuery(`(max-width: ${medium}px)`);

  const btnType = showFilterOptions ? 'primary' : 'secondary';
  const ariaLabel = showFilterOptions
    ? 'Close Filter panel'
    : 'Open Filter panel';
  return (
    <MLButton
      ref={ref}
      className={classNames(s.filterButton, {
        [s.filterButtonMedium]: isMedium,
      })}
      btnType={btnType}
      testId="show_filters"
      ariaLabel={ariaLabel}
      onClick={() => {
        if (sidePanelState.open) {
          sidePanelDispatch({ type: CLOSE_SIDE_PANEL });
        }
        dispatch(toggleShowFilterOptionsGradebook());
      }}
    >
      <MLIcon
        className={
          showFilterOptions ? s.buttonLeftIconSelected : s.buttonLeftIcon
        }
        type="list_right"
        testId="show_filter_button_icon"
      />
      <Typography
        className={classNames(s.buttonLabel, {
          [s.buttonLabelMedium]: isMedium,
        })}
      >
        Filter
      </Typography>
    </MLButton>
  );
});

export default FilterButton;
